import { render, staticRenderFns } from "./ToolSection.vue?vue&type=template&id=56acdbd7&scoped=true"
import script from "./ToolSection.vue?vue&type=script&lang=js"
export * from "./ToolSection.vue?vue&type=script&lang=js"
import style0 from "./ToolSection.vue?vue&type=style&index=0&id=56acdbd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56acdbd7",
  null
  
)

export default component.exports